
define(['jquery', 'underscore', 'app-common/component/timeout-warning', 'common/location'], function($, _, timeoutWarning, location) {
  return function(url, type, data, dataType, cors, timeout, contentType) {
    var settings;
    if (dataType == null) {
      dataType = 'json';
    }
    if (cors == null) {
      cors = false;
    }
    if (contentType == null) {
      contentType = 'json';
    }
    settings = {
      url: "" + location.apiRoot + url,
      type: type || 'GET',
      dataType: dataType,
      contentType: "application/" + contentType + "; charset=UTF-8",
      xhrFields: {
        withCredentials: true
      }
    };
    if ((data != null) && (type === 'PUT' || type === 'POST' || type === 'DELETE') && contentType === 'json') {
      settings.data = _.isObject(data) ? JSON.stringify(data) : data;
    } else if (data != null) {
      settings.data = data;
    }
    if (cors) {
      settings.xhrFields = {
        withCredentials: true
      };
    }
    if (timeout) {
      settings.timeout = timeout;
    }
    timeoutWarning.reset();
    return $.ajax(settings);
  };
});
